import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getGuestData } from '../services/api';
import { GuestData } from '../types';
import WeddingInvitation from '../components/WeddingInvitation';
import HelloPage from '../components/HelloPage';
import ProgressBar from '../components/ProgressBar';

const WeddingInvitationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  const [guestData, setGuestData] = useState<GuestData | null>(null);
  const [loading, setLoading] = useState(true);
  const [isValidGuest, setIsValidGuest] = useState(false);

  useEffect(() => {
    const fetchGuestData = async () => {
      if (code) {
        try {
          const data = await getGuestData(code);
          if (data) {
            setGuestData(data);
            setIsValidGuest(true);
          } else {
            setIsValidGuest(false);
          }
        } catch (error) {
          setIsValidGuest(false);
        }
      } else {
        setIsValidGuest(false);
      }
      setLoading(false);
    };

    fetchGuestData();
  }, [code]);

  if (loading) {
    return (
      <section className="loading-page">
        {/* Background with gradient using existing palette */}
        <div className="loading-background">
          <div className="loading-background-overlay"></div>
        </div>

        {/* Header */}
        <div className="loading-header">
          <h1 className="loading-subtitle">
            BIENVENIDO
          </h1>
          <h2 className="loading-title-script">
            Validando Invitación
          </h2>
        </div>

        {/* Content */}
        <div className="loading-display">
          <div className="loading-card">
            <div className="loading-spinner">
              <div className="spinner-circle"></div>
            </div>
            <ProgressBar duration={3000} />
          </div>
        </div>

        {/* Bottom spacing */}
        <div className="loading-bottom"></div>
      </section>
    );
  }

  if (!isValidGuest || !guestData) {
    return <HelloPage />;
  }

  return <WeddingInvitation guestData={guestData} />;
};

export default WeddingInvitationPage;
